window.dremVars.orderDeliveryAddress = {
	region: "",
	city: "",
	street: "",
	number: "",
	flat: ""
};

window.dremVars.orderUser = {
	name: "",
	phone: ""
};

window.dremVars.isShowCoupon = false;

window.k1Order = {
	setMinQuantity: function (elem) {
		elem.setAttribute('data-min-value', true);
	},

	setMaxQuantity: function (elem) {
		elem.setAttribute('data-max-value', true);
	},

	removeAttribute: function (elem) {
		elem.removeAttribute('data-max-value');
		elem.removeAttribute('data-min-value');
	},

	checkQuantity: function () {
		this.getAllItemBox().forEach(elem => {
			let maxQuantity = elem.getAttribute('data-k1-quantity');
			let input = elem.querySelector('.k1-cart-quantity-count input');
			switch (input.value) {
				case maxQuantity:
					this.setMaxQuantity(elem);
					break;
				case '1':
					this.setMinQuantity(elem);
					break;
				default:
					this.removeAttribute(elem);
					break;
			}
		})
	},

	getAllGoodsInCart: function () {
		return document.querySelectorAll('.order-cart__item .order-cart__amount');
	},

	getAllItemBox: function () {
		return [...this.getAllGoodsInCart()]
		// return [...this.getAllGoodsInCart()].map(elem => elem.querySelector('.k1-cart-quantity-box'))
	},

	disableQuantityButton: function (elem) {
		elem.style.pointerEvents = 'none'
	},

	enableQuantityButton: function (elem) {
		elem.style.pointerEvents = 'auto'
	},

	bindItemBoxes: function (arr) {
		arr.forEach(elem => {
			elem.addEventListener("click", () => {
				setTimeout(() => {
					BX.Sale.OrderAjaxComponent.sendRequest("refreshOrderAjax")
				}, 1000)

			})
		})
	},

	dropTotalBlock: function () {
		let totalBlock, totalNewHome;
		totalBlock = document.getElementById("bx-soa-total");
		totalNewHome = document.getElementById("k1-aside-order");
		if (!totalNewHome || !totalBlock) return false;
		totalNewHome.append(totalBlock);
	},

	dropCommentBlock: function () {
		let commentField, newHome;
		newHome = document.querySelector(".k1-new-home-comment-js");
		commentField = document.querySelector(".order-info__comment-field");
		if (newHome.querySelector(".order-info__comment-field")) {
			newHome.querySelector(".order-info__comment-field").remove();
		}
		if (!newHome || !commentField) return false;
		newHome.append(commentField);

	},

	setMaxHeightOrderSectionContainer: function (elements) {
		for (let i = 0; i < elements.length; i++) {
			if (elements[i].querySelector(".k1-chosen-delivery")) {
				let tmpHeight = 0;

				tmpHeight = elements[i].querySelector(".k1-chosen-delivery").clientHeight + 2;
				tmpHeight += this.setMaxHeightDeliverySection(this.getDeliveryElements().box);
				elements[i].closest(".order-info__box").setAttribute("data-max-height", tmpHeight);
			}

		}
	},

	setMaxHeightDeliverySection: function (element) {
		let inputs = element.closest(".order-info__content").querySelector(".order-info__delivery-inputs-box");
		// order-info__delivery-inputs-box
		let maxHeight = 0;
		[...element.children].forEach(elem => {
			maxHeight += elem.clientHeight + 2;
		});
		maxHeight += inputs.clientHeight;

		element.setAttribute("data-max-height", maxHeight);
		return maxHeight;
	},

	hideSections: function () {
		let contentArray = document.querySelectorAll(".order-info__content");
		contentArray.forEach(elem => {
			if (!elem.closest(".opened")) {
				elem.style.maxHeight = 0;
				elem.style.padding = 0;

			}
		})
	},

	toggleDeliveryList: function (element, event) {
		if (!event) {
			window.k1Order.getDeliveryElements().title.classList.remove("opened");
			window.k1Order.getDeliveryElements().title.nextElementSibling.style.maxHeight = 0;
			return false;
		}
		element.classList.toggle("opened");
		if (element.classList.contains("opened")) {
			element.nextElementSibling.style.maxHeight = element.nextElementSibling.getAttribute("data-max-height") + "px";
		} else {
			element.nextElementSibling.style.maxHeight = 0;
		}
	},

	getSectionsElements: function () {
		return {
			buttons: document.querySelectorAll(".k1-toggle-order-section"),
			contents: document.querySelectorAll(".order-info__content")
		}
	},

	getDeliveryElements: function () {
		return {
			selected: document.querySelector(".order-info__delivery-item.bx-selected"),
			box: document.querySelector(".order-info__delivery-items"),
			title: document.querySelector(".k1-chosen-delivery")
		}
	},

	copyDeliverySelect: function () {
		if (!document.querySelector(".order__order")) return false;
		if (document.querySelector(".k1-chosen-delivery")) document.querySelector(".k1-chosen-delivery").remove();
		let currentDelivery = BX.create("DIV", {
			props: {
				className: "k1-chosen-delivery order-info__delivery-chosen opened"
			},
			html: this.getDeliveryElements().selected.outerHTML,

		});
		let chevron = BX.create("DIV", {
			props: {
				className: "order-info__toggle-button order-info__delivery-chosen-chevron"
			}
		});
		currentDelivery.append(chevron);
		this.getDeliveryElements().box.before(currentDelivery);

		this.toggleDeliveryList(this.getDeliveryElements().box)
		this.cleanChosenDelivery(currentDelivery);
	},

	cleanChosenDelivery: function (element) {
		element.querySelector(".bx-selected").classList.remove("bx-selected")
	},

	toggleOrderPageSection: function (button) {
		const box = button.target.closest(".order-info__box");
		const content = box.querySelector(".order-info__content");

		box.classList.toggle("opened");
		if (box.classList.contains("opened")) {
			content.style.cssText = `max-height: ${box.getAttribute("data-max-height")}px; padding: 10px 0;`
		} else {

			if ( content.querySelector('.k1-chosen-delivery') != undefined){
				content.querySelector('.k1-chosen-delivery').classList.remove('opened');
				content.querySelector('.order-info__delivery-items').style.maxHeight = 0;

			}
			content.style.cssText = `max-height: 0; padding: 0;`
		}

	},

	getDeliveryAddressInputs: function () {
		return {
			region: BX("k1-order-delivery-region"),
			city: BX("k1-order-delivery-city"),
			street: BX("k1-order-delivery-street"),
			number: BX("k1-order-delivery-number"),
			flat: BX("k1-order-delivery-flat")
		}
	},

	getUserInputs: function () {
		return {
			name: BX("soa-property-1"),
			phone: BX("soa-property-3"),
		}
	},

	getRequiredFields: function () {
		return {
			name: document.querySelector("[name=ORDER_PROP_1]")
		}
	},

	getCouponBlockElements: function () {
		return {
			main: document.querySelector(".order-aside__total-coupon-block"),
			toggleButton: document.querySelector(".k1-order-promocode-js .order-aside__total-value"),
			couponField: document.querySelector(".k1-order-pay-coupon-block")
		}
	},

	inputUserInputs: function (input) {
		let objKey = input.getAttribute("data-k1-user-input");
		window.dremVars.orderUser[objKey] = input.value;
	},

	// cleanUserNameField: function () {
	// 	if (BX("soa-property-1")) BX("soa-property-1").value = "";
	// },

	validateUserFields: function (input, button) {
		if (input && input.getAttribute("id") === "soa-property-1") {
			let nameField = BX("soa-property-1");

			if (nameField.value.length == 0) {
				nameField.closest(".order-info__user-input").classList.add("k1-error")
			} else {
				nameField.closest(".order-info__user-input").classList.remove("k1-error")
			}
		}

		if (input && input.getAttribute("id") === "soa-property-3") {
			let phoneField = BX("soa-property-3");
			let typePhone = 18;

			if (phoneField.value[0] == '8') typePhone = 17;


			if (phoneField.value.length < typePhone) {
				phoneField.closest(".order-info__user-input").classList.add("k1-error")
			} else {
				phoneField.closest(".order-info__user-input").classList.remove("k1-error")
			}
		}

		if (input && input.getAttribute("id") === "soa-property-2") {
			let emailField = BX("soa-property-2");

			if(emailField.value == ''){
				emailField.closest(".order-info__user-input").classList.remove("k1-error")

			}else{
				if (!window.k1ValidateForm.validateEmail(emailField.value)) {
					emailField.closest(".order-info__user-input").classList.add("k1-error")
				} else {
					emailField.closest(".order-info__user-input").classList.remove("k1-error")
				}

			}


		}

		if (button && button.closest(".order-aside__save-btn")) {
			// if (window.dremVars.orderUser.name && window.dremVars.orderUser.surname && window.dremVars.orderUser.phone) {
			if (window.dremVars.orderUser.name &&  window.dremVars.orderUser.phone) {
				this.writeUserField();
				this.writeDeliveryAddressField();
			} else {
				if (window.dremVars.orderUser.name === "") {
					this.getUserInputs().name.closest(".order-info__user-input").classList.add("k1-error")
				} else {
					this.getUserInputs().name.closest(".order-info__user-input").classList.remove("k1-error")
				}

				if (window.dremVars.orderUser.phone === "") {
					this.getUserInputs().phone.closest(".order-info__user-input").classList.add("k1-error")
				} else {
					this.getUserInputs().phone.closest(".order-info__user-input").classList.remove("k1-error")
				}
				this.writeUserField(true)
			}
		}
	},

	writeUserField: function (clean = false) {
		if (window.dremVars.orderUser.name !== "") {
			this.getUserInputs().name.value = window.dremVars.orderUser.name;
			this.getUserInputs().name.closest(".default-form-input-text-js").classList.remove("k1-error");
		}

		if (window.dremVars.orderUser.phone !== "") {
			this.getUserInputs().phone.value = window.dremVars.orderUser.phone;
			this.getUserInputs().phone.closest(".default-form-input-text-js").classList.remove("k1-error");
		}
	},

	/**
	 * @param {HTMLElement} input 
	*/
	inputDeliveryAddressInputs: function (input) {
		let objKey = input.getAttribute("data-k1-delivery-name");
		window.dremVars.orderDeliveryAddress[objKey] = input.value;
		this.writeDeliveryAddressField()

		if (input.value.length > 0 && input.closest('div').classList.contains('k1-error')) {
			input.closest('div').classList.remove('k1-error')
		}
	},

	writeDeliveryAddressField: function () {
		let addressField = BX("soa-property-7");
		let currentString = `
			Область: ${window.dremVars.orderDeliveryAddress.region},
			Город: ${window.dremVars.orderDeliveryAddress.city},
			Улица: ${window.dremVars.orderDeliveryAddress.street},
			Дом: ${window.dremVars.orderDeliveryAddress.number},
			Квартира: ${window.dremVars.orderDeliveryAddress.flat}
		`;
		currentString = currentString.trim();
		addressField.value = currentString;

		if (window.dremVars.orderDeliveryAddress.region !== "") {
			this.getDeliveryAddressInputs().region.value = window.dremVars.orderDeliveryAddress.region;
		}
		if (window.dremVars.orderDeliveryAddress.city !== "") {
			this.getDeliveryAddressInputs().city.value = window.dremVars.orderDeliveryAddress.city;
		}
		if (window.dremVars.orderDeliveryAddress.street !== "") {
			this.getDeliveryAddressInputs().street.value = window.dremVars.orderDeliveryAddress.street;
		}
		if (window.dremVars.orderDeliveryAddress.number !== "") {
			this.getDeliveryAddressInputs().number.value = window.dremVars.orderDeliveryAddress.number;
		}
		if (window.dremVars.orderDeliveryAddress.flat !== "") {
			this.getDeliveryAddressInputs().flat.value = window.dremVars.orderDeliveryAddress.flat;
		}
	},

	getDeliveryInfo: function () {
		let priceInputs = document.querySelectorAll(".k1-delivery-price");
		let deliveryPriceObject = {};
		priceInputs.forEach(elem => {
			let tmpKey = elem.getAttribute("data-bitrix-id");
			deliveryPriceObject[tmpKey] = {
				id: elem.getAttribute("id"),
				price: elem.getAttribute("data-price")
			}
		});
		// console.log(deliveryPriceObject);
		return deliveryPriceObject
	},

	printDeliveryPrice: function () {
		let obj = this.getDeliveryInfo();
		let keys = Object.keys(obj);
		keys.forEach(key => {
			let currentDelivery = document.querySelectorAll(`input[name=DELIVERY_ID]`);
			currentDelivery.forEach(input => {
				if (input.getAttribute("value") === obj[key].id) {
					let priceBox = input.closest(".order-info__delivery-item").querySelector(".k1-delivery-price-box-js");
					priceBox.textContent = obj[key].price + " р."
				}
			});
		})
	},

	removeStylesTag: function () {
		document.querySelectorAll(".order-aside__total-value").forEach(elem => {
			elem.removeAttribute("style");
		})
	},
	// k1-delivery-price-box-js

	bindElements: function () {

		BX.bind(this.getCouponBlockElements().toggleButton, "click", this.toggleCouponField);

		this.getSectionsElements().buttons.forEach(button => {
			BX.bind(button.closest(".order-info__title"), "click", BX.proxy(window.k1Order.toggleOrderPageSection, this));


			// BX.unbind(button.closest(".order-info__title"), "click", function () {
			// 	window.k1Order.toggleOrderPageSection(this)
			// });
			// BX.bind(button.closest(".order-info__title"), "click", function () {
			// 	window.k1Order.toggleOrderPageSection(this)
			// })
		});


		Object.values(this.getDeliveryAddressInputs()).forEach(input => {
			// BX.unbind(input, "input", function() {
			// 	window.k1Order.inputDeliveryAddressInputs(input)
			// });
			BX.bind(input, "input", function () {
				window.k1Order.inputDeliveryAddressInputs(input)
			})
		});

		Object.values(this.getUserInputs()).forEach(input => {
			BX.bind(input, "input", function () {
				window.k1Order.inputUserInputs(input)
			})
		});

		BX.bind(BX("order-consent-js"), "click", function () {
			BX("order-consent-original-js").checked = !BX("order-consent-original-js").checked;
			window.k1Order.disableOrderSaveButton(BX("order-consent-original-js").checked)
		})

	},

	disableOrderSaveButton: function (isChecked) {
		if (!isChecked) {
			BX("k1-order-save-btn").classList.add("dont-save")
		} else {
			BX("k1-order-save-btn").classList.remove("dont-save")
		}
	},

	toggleCouponField: function () {
		let _this = window.k1Order;
		window.dremVars.isShowCoupon = !window.dremVars.isShowCoupon;
		window.dremVars.isShowCoupon ? _this.showCouponField(_this.getCouponBlockElements().couponField) : _this.hideCouponField(_this.getCouponBlockElements().couponField);
		// window.dremVars.isShowCoupon ? this.textContent = "Закрыть" : this.textContent = "Добавить";
		// console.log('click');
	},

	showCouponField: function (field) {
		field.style.maxHeight = "none";
		this.getCouponBlockElements().main.classList.add('open');
		this.getCouponBlockElements().toggleButton.textContent = "Закрыть";
		// field.style.border = "1px solid #DADADA";
	},

	hideCouponField: function (field) {
		field.style.maxHeight = 0;
		this.getCouponBlockElements().main.classList.remove('open');
		this.getCouponBlockElements().toggleButton.textContent = "Добавить";
		// field.style.border = "none";
	},

	getCouponStatus: function () {
		const couponList = BX("k1-aside-order").querySelectorAll(".bx-soa-coupon-item strong");
		if (!couponList || !couponList.length) return false;
		return couponList[couponList.length - 1].getAttribute("class");
	},

	setCouponStatus: function () {
		const status = this.getCouponStatus(),
			field = document.querySelector(".order-aside__coupon-input"),
			infoBlock = document.querySelector(".order-aside__coupon-info-block"),
			button = document.querySelector(".order-aside__coupon-fake-button");
		switch (status) {
			case "bx-soa-coupon-item-danger":
				infoBlock.textContent = "Неверный купон";
				infoBlock.classList.remove("success");
				infoBlock.style.display = "block";
				break;
			case "bx-soa-coupon-item-success":
				field.style.display = "none";
				button.style.display = "none";
				infoBlock.textContent = "Скидка применена";
				infoBlock.classList.add("success");
				infoBlock.style.display = "block";
				break;
			case "bx-soa-coupon-item-used":
				infoBlock.textContent = "Этот купон денег не сэкономит";
				infoBlock.style.display = "block";
				infoBlock.classList.remove("success");
				break;

		}
	},

	doItAfterAJAX: function () {
		this.copyDeliverySelect();
		this.dropCommentBlock();
		this.printDeliveryPrice();
		// this.dropSaveOrderBox();
		this.removeStylesTag();
		this.setMaxHeightDeliverySection(this.getDeliveryElements().box);
		BX.unbind(this.getDeliveryElements().title, "click", function () {
			window.k1Order.toggleDeliveryList(this, event)
		});

		BX.bind(this.getDeliveryElements().title, "click", function () {
			window.k1Order.toggleDeliveryList(this, event)
		});

		// this.showCouponField(this.getCouponBlockElements().couponField);
		this.setCouponStatus();
		
		BX.unbindAll(this.getCouponBlockElements().toggleButton);
		BX.bind(this.getCouponBlockElements().toggleButton, "click", this.toggleCouponField);

		Object.values(this.getDeliveryAddressInputs()).forEach(input => {
			BX.unbindAll(input);
			BX.bind(input, "input", function () {
				window.k1Order.inputDeliveryAddressInputs(input)
			})
		});
		
		// window.BX.Sale.OrderAjaxComponent.editActiveBasketBlock(false);
	},

	init: function () {
		if (!document.querySelector(".order__order")) return false;
		if (!document.querySelector("#order-consent-original-js")) return false;
		BX("order-consent-original-js").checked = false;
		this.dropTotalBlock();
		this.dropCommentBlock();
		// this.cleanUserNameField();
		this.copyDeliverySelect();
		// setTimeout(() => {
		this.setMaxHeightDeliverySection(this.getDeliveryElements().box);
		// }, 100)
		this.bindElements();
		this.setMaxHeightOrderSectionContainer(this.getSectionsElements().contents);
		this.bindItemBoxes(this.getAllItemBox());
		this.checkQuantity();
		this.hideSections();
		this.printDeliveryPrice();
		// this.dropSaveOrderBox();
		this.removeStylesTag();
		this.setCouponStatus();
		this.writeUserField(false);
		this.writeDeliveryAddressField();
		// this.showCouponField(this.getCouponBlockElements().couponField)

		BX.unbind(this.getDeliveryElements().title, "click", function () {
			window.k1Order.toggleDeliveryList(this, event)
		});

		BX.bind(this.getDeliveryElements().title, "click", function () {
			window.k1Order.toggleDeliveryList(this, event)
		});

	}
};

window.addEventListener('DOMContentLoaded', function () {
	window.k1Order.init();
});